import { getLocalStorageToken } from 'store/localStorage'
import React from 'react'
import logo from 'assets/icon.svg'
import hamburger from './assets/hamburger.svg'
import { Link } from 'react-router'
import UserAvatar from 'components/UserAvatar/UserAvatar'
import userQuery from 'graphql/queries/viewerQuery'
import { SidebarMenuContext } from 'providers/SidebarMenuProvider'
import SearchBar from 'containers/SearchBar/SearchBar'
import { WhatsNewDialog } from 'components/WhatsNewDialog/WhatsNewDialog'
import { BossFilterDropdown } from 'components/BossFilter/BossFilterDropdown'
import { useQuery } from "@apollo/client/react";
import { viewerQuery, viewerQueryVariables } from 'graphql/queries/types/viewerQuery'

const Header: React.FC = () => {
  const { data } = useQuery<viewerQuery, viewerQueryVariables>(userQuery, {
    variables: { token: getLocalStorageToken() },
  })
  const username = data && data.viewer ? data.viewer.username : ''
  return (
    <div className="w-full h-[75px] fixed top-0 left-0 bg-white flex z-903 border-b border-gray-200">
      <Link to="/" className="hidden sm:block">
        <div className="w-[76px] h-[75px] border-r border-gray-200 content-center flex-center cursor-pointer">
          <img alt="Logo" src={logo} className="w-8 h-8 sm:w-10 sm:h-10" />
        </div>
      </Link>

      <SidebarMenuContext.Consumer>
        {(p) => {
          const { hidden, actions } = p ?? {}
          const { openMenu, closeMenu } = actions ?? {}
          return (
            <div
              className="block sm:hidden"
              onClick={() => {
                hidden ? openMenu?.() : closeMenu?.()
              }}
            >
              <div className="w-[76px] h-[75px] border-r border-gray-200 content-center flex-center cursor-pointer">
                <img
                  alt="Logo"
                  src={hidden ? hamburger : logo}
                  className="w-8 h-8 sm:w-10 sm:h-10"
                />
              </div>
            </div>
          )
        }}
      </SidebarMenuContext.Consumer>

      <div className="grow flex items-center">
        <div className="grow">
          <SearchBar />
        </div>
        <div className="hidden sm:flex items-center px-2">
          <BossFilterDropdown />
        </div>
        <WhatsNewDialog />
        <div className="py-0 px-4 sm:px-8 flex items-center border-l border-gray-200 h-full">
          <UserAvatar username={username ?? ''} />
        </div>
      </div>
    </div>
  )
}

export default Header
